export default __webpack_public_path__ + "static/media/transport.10f78356.svg";